/* eslint-disable max-len */
import moment from 'moment';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AnimatedList from '../../../../components/Animation/AnimatedList';
import AnimatedButton from '../../../../components/Animation/AnimatedButton';
import { useSelector } from 'react-redux';
import FormatDateString from '../../../../CommonMethods/FromatDateString';
const TableBody = ({lastIndex,tableData, indexNum,selectedIndex, setSelectedIndex, selectedRef, setConfirmationState, email, isSideNavBar }) => {
    /**
     * This function sets the confirmation state to activate or deactivate an item in a table.
     */
    const location=useNavigate();
    const {userType}=useSelector(state=>state.auth)
    const [searchParams, setSearchParams] = useSearchParams('')

    /**
     * The function onClickActivation handles different actions based on the target id, such as viewing
     * data, resetting passwords, or activating/deactivating an item.
     */
    const onClickActivation = (e) => {
        e.preventDefault();
        setSelectedIndex(null);
        if(e.target.id === 'View') {
            setConfirmationState({item: tableData, view : true})
        } else if(e.target.id === 'Reset Password'){
            setConfirmationState({item: tableData, status: "Reset Password"})      
        }else
        {
            setConfirmationState({item: tableData, status: !tableData.status ? 'Activate' : 'Deactivate'})
        }
    }

    /**
     * The function `handleEditClick` redirects the user to the edit page for a specific branch.
     */
    const handleEditClick = () => {
        const queryString = window.location.search;
        location(`/manage-branches/onboard-new-branch/edit/${tableData._id}?${searchParams.toString()}`,{state: {redirect: 'fromListingScreen'}})
    }
    
    /**
     * The function `handelActionButton` sets the selected index to the provided index number.
     */
    const handelActionButton = async(indexNum) =>{
        setSelectedIndex(indexNum)
    }

    /**
     * The handleClickViewClick function redirects the user to a specific branch details page.
     */
    const handleClickViewClick=()=>{

        location(`/manage-branches/${tableData._id}*branch_details?${searchParams.toString()}`)
    }

    return (
        <>
            <AnimatedList
                cursorpointer
                title={`View Branch Details`}
                handleClick={(e)=>{
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        handleClickViewClick()
                    }
                }}
                keyItem={indexNum}
                rowStatus={tableData.status}
                child={
                    <>
                        <td class="text-start">{tableData?.branch_name}</td>
                        {isSideNavBar &&
                            <>
                                <td class="text-start">{tableData?.area}</td>
                                <td class="text-start">{tableData?.city}</td>
                            </>
                        }
                        <td class="text-start">{tableData?.poc_name}</td>
                        <td class="text-start">{tableData?.poc_email_address}</td>
                        <td class="text-left">{tableData?.gst_number === "" || tableData?.gst_number === undefined ? '-' : tableData?.gst_number}</td>
                        <td class="text-left">{tableData?.pan_number}</td>
                        {isSideNavBar && <td class="text-left">{FormatDateString(tableData.created_at)}</td>}
                        <td class="table-cell">
                            <div className='flex justify-center'>
                                <div class={`w-fit rounded ${tableData.status ? 'bg-[#C5FFD5]' : 'bg-[#B3BBC1]'} flex items-center justify-center py-1 px-2.5`}>
                                    <img loading="lazy" decoding="async"src={tableData.status ? "/images/successDot.svg" : "/images/inactive-Dot.svg" } alt="icon"/>
                                    <span class="text-f7 font-normal text-[#031624] pl-1">{tableData.status ? 'Active' : 'Inactive'}</span>
                                </div>
                            </div>
                        </td>
                        <td class="text-left prevent-click">
                            <div class="relative flex items-center justify-center prevent-click" data-te-dropdown-position="dropstart">
                                <button 
                                    type="button" 
                                    class="list-more-btn prevent-click " 
                                    id={tableData.email_address}
                                    onClick={() =>handelActionButton(indexNum) }
                                >
                                    <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="icon" class="w-[6px] h-[25px] prevent-click"/>
                                </button>
                                {selectedIndex === indexNum && <ul ref={selectedRef} className={`list-more-optns-div ${(indexNum+1 === 10 || indexNum+2 === 10) ? (tableData.status?'top2':'top3') : ''} [&[data-te-dropdown-show]]:block prevent-click`}
                                    aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref>
                                    <li title='View Details'>
                                        <AnimatedButton 
                                            handleClick={()=>{}} 
                                            buttonName={"View Details"}
                                            link={`/manage-branches/${tableData._id}*branch_details?${searchParams.toString()}`}
                                            className="list-more-optns prevent-click"
                                        />
                                    </li>
                                    {tableData.status && <li title='Edit Branch'>
                                        <AnimatedButton 
                                            handleClick={()=>{handleEditClick()}} 
                                            buttonName={"Edit Branch"}
                                            className="list-more-optns prevent-click"
                                        />
                                    </li>}       
                                    {email!==tableData.email_address && userType!=='branch-user'  &&
                                    <>
                                        {/* <li>
                                            <AnimatedButton 
                                                handleClick={handleEditClick} 
                                                buttonName={"Edit"}
                                                className="block w-full whitespace-nowrap bg-transparent px-4 py-1.5 font-normal text-[#000000] text-start"
                                            />
                                        </li> */}
                                        <li title={!tableData.status ? "Activate" : "Deactivate"}>
                                            <AnimatedButton 
                                                handleClick={(e)=>onClickActivation(e)} 
                                                buttonName={!tableData.status ? "Activate" : "Deactivate"}
                                                className="list-more-optns prevent-click"/>
                                        </li>
                                        {/* <li>
                                            <AnimatedButton 
                                                handleClick={onClickActivation} 
                                                buttonName={"Reset Password"}
                                                className="block w-full whitespace-nowrap bg-transparent px-4 py-1.5 font-normal text-[#000000] text-start"
                                            />
                                        </li> */}
                                    </>
                                    }
                                    
                                </ul>}
                            </div>
                        </td>
                    </>
                }/>
        </>
    );
}

export default TableBody;
